/**
 * Singleton currency store.
 * Call hydrateCurrency(data) once at app startup (App.js useEffect).
 * All exported helpers read from the live store — no re-renders required
 * since currency changes are rare and take effect on next page load.
 */

let _cur = {
  code:          'KES',
  name:          'Kenyan Shilling',
  symbol:        'KES',
  locale:        'en-KE',
  decimalPlaces: 2,
};

/** Called once from App.js after fetching /api/currencies/local */
export const hydrateCurrency = (data) => {
  if (data && data.code) _cur = { ..._cur, ...data };
};

/** Current local currency object (read-only snapshot) */
export const getCurrency = () => ({ ..._cur });

/** Currency symbol string, e.g. "KES" or "$" */
export const sym = () => _cur.symbol;

/** BCP-47 locale string, e.g. "en-KE" */
export const locale = () => _cur.locale;

/** Format a number as a currency amount (no symbol prefix) */
export const fmt = (n) =>
  Number(n || 0).toLocaleString(_cur.locale, { minimumFractionDigits: _cur.decimalPlaces });

/** Format a number without forced decimal places (whole numbers, counts) */
export const fmtN = (n) => Number(n || 0).toLocaleString(_cur.locale);

/** Format as currency with symbol prefix, e.g. "KES 12,345.00" */
export const fmtMoney = (n) => `${_cur.symbol} ${fmt(n)}`;

/** Format a date using the locale. opts are passed directly to toLocaleDateString. */
export const fmtDate = (d, opts = {}) =>
  d ? new Date(d).toLocaleDateString(_cur.locale, opts) : '—';
